import call from 'images/consultancy_images/call.jpg'
import how_expert from 'images/consultancy_images/how_expert.jpg'
import stratagey from 'images/consultancy_images/how_stratagey.jpg'
import progress from 'images/consultancy_images/how_progress.jpg'

export const consultancySteps = [
    {
        id: 1,
        stepNumber: "Step 1",
        title: "Book a Free Discovery Call",
        description: "Discuss your unique needs and goals for natural living.",
        image: call
    },
    {
        id: 2,
        stepNumber: "Step 2",
        title: "Expert Review",
        description: "We’ll outline next steps and consultancy fees, with adjustments as needed.",
        image: how_expert
    },
    {
        id: 3,
        stepNumber: "Step 3",
        title: "Personalized Guidance",
        description: "Receive tailor and sustainable strategies from experts.",
        image: stratagey
    },
    {
        id: 4,
        stepNumber: "Step 4",
        title: "Regular Check-ins",
        description: "Monitor progress, address challenges, and refine your plan.",
        image: progress
    }
];
